import {
  GetLatestNotifications,
  GetNotificationList,
  NotificationRead,
  NotificationReadAll,
} from "./api";

import http from "config/http";

const notificationApi = {
  getLatestNotifications: async () => await http.get(GetLatestNotifications),

  notificationReadAll: async () => await http.post(NotificationReadAll),

  notificationRead: async (id) => await http.post(NotificationRead, { id }),

  getNotificationList: async ({ pageNumber = 1, pageSize = 10 }) =>
    await http.get(GetNotificationList({ pageNumber, pageSize })),
};

export default notificationApi;
